import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Gift, Copy, Share2, Check } from "lucide-react";
import { toast } from "sonner";

export default function Refer() {
  const { user } = useAuth();
  const [data, setData] = useState({ code: "", invited: 0, rewarded: 0, bonus_days: 0 });
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/referral/me"); setData(data); } catch {}
    })();
  }, []);

  const link = data.code ? `${window.location.origin}/register?ref=${data.code}` : "";

  const copy = async () => {
    try { await navigator.clipboard.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 1800); toast.success("Link copied"); }
    catch { toast.error("Couldn't copy — long-press to copy manually"); }
  };

  const shareWhatsApp = () => {
    const msg = encodeURIComponent(
      `मला Sanyog matrimony app वर सामील व्हा. माझा referral link वापरला तर तुम्हाला आणि मला Premium चे 30 दिवस मोफत मिळतील: ${link}`
    );
    window.open(`https://wa.me/?text=${msg}`, "_blank");
  };

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-20" data-testid="refer-page">
      <Gift className="h-8 w-8 text-[#C85A44] mb-6" strokeWidth={1.25} />
      <p className="overline mb-3">Invite friends</p>
      <h1 className="font-serif-display text-4xl md:text-5xl tracking-tight leading-tight">
        Share Sanyog. Both of you get <em className="italic text-[#C85A44]">30 days Premium</em>.
      </h1>
      <p className="mt-5 text-[#5d574f] max-w-xl">
        When a friend signs up with your link and pays for any Premium plan, you both earn 30 free days of Premium.
        Simple, fair, and the warmest way to grow Sanyog.
      </p>

      <div className="mt-12 p-6 md:p-8 rounded-3xl bg-white border border-[#E2DCD0]">
        <p className="overline mb-3">Your referral code</p>
        <div className="font-serif-display text-5xl tracking-widest text-[#C85A44] mb-6" data-testid="referral-code">{data.code || "—"}</div>
        <div className="flex flex-col sm:flex-row items-stretch gap-2 mb-6">
          <input readOnly value={link} className="flex-1 rounded-xl border border-[#E2DCD0] bg-[#F9F8F6] px-4 py-3 text-sm font-mono"/>
          <button onClick={copy} data-testid="copy-referral" className="rounded-full bg-[#2C2A28] hover:bg-black text-white px-5 py-3 text-sm inline-flex items-center justify-center gap-2 transition">
            {copied ? <><Check className="h-4 w-4"/> Copied</> : <><Copy className="h-4 w-4"/> Copy link</>}
          </button>
          <button onClick={shareWhatsApp} data-testid="share-whatsapp" className="rounded-full bg-[#2E5C46] hover:opacity-90 text-white px-5 py-3 text-sm inline-flex items-center justify-center gap-2 transition">
            <Share2 className="h-4 w-4"/> WhatsApp
          </button>
        </div>
        <div className="grid grid-cols-3 gap-4 pt-4 border-t border-[#E2DCD0]">
          <Stat label="Friends invited" value={data.invited} testid="ref-invited" />
          <Stat label="Premium earned" value={data.rewarded} testid="ref-rewarded" />
          <Stat label="Bonus days" value={data.bonus_days} testid="ref-bonus" />
        </div>
      </div>

      <p className="mt-8 text-xs text-[#8C857B] text-center">
        Bonus is credited automatically when your friend completes their first Premium payment.
      </p>
    </div>
  );
}

function Stat({ label, value, testid }) {
  return (
    <div className="text-center" data-testid={testid}>
      <div className="font-serif-display text-3xl text-[#2C2A28]">{value}</div>
      <div className="text-xs uppercase tracking-widest text-[#8C857B] mt-1">{label}</div>
    </div>
  );
}
